var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormalAcMax22KwKaracsony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3529 25.7068H10.1029H1.89622C1.61007 25.7066 1.3292 25.6342 1.08112 25.497C0.833072 25.3599 0.626624 25.1629 0.48132 24.926C0.336046 24.6891 0.25667 24.4202 0.250402 24.1454C0.244135 23.8705 0.31117 23.5985 0.445432 23.3557L4.04989 16.8387L4.23947 16.4959L3.84875 16.4683C3.5669 16.4484 3.29544 16.3585 3.06025 16.2078C2.8251 16.0571 2.63431 15.8508 2.5054 15.6091C2.37651 15.3674 2.31359 15.0981 2.32219 14.8268C2.33079 14.5554 2.41066 14.2903 2.55471 14.0567L2.55473 14.0566L10.5869 1.02645C10.7326 0.790579 10.939 0.594623 11.1867 0.458272C11.4344 0.3219 11.7146 0.25 12 0.25C12.2854 0.25 12.5656 0.3219 12.8133 0.458272C13.061 0.594623 13.2674 0.790579 13.4131 1.02645L21.4453 14.0566L21.4453 14.0567C21.5893 14.2903 21.6692 14.5554 21.6778 14.8268C21.6864 15.0981 21.6235 15.3674 21.4946 15.6091C21.3657 15.8508 21.1749 16.0571 20.9397 16.2078C20.7046 16.3585 20.4331 16.4484 20.1512 16.4683L19.7605 16.4959L19.9501 16.8387L23.5546 23.3557C23.6888 23.5985 23.7559 23.8705 23.7496 24.1454C23.7433 24.4202 23.664 24.6891 23.5187 24.926C23.3734 25.1629 23.1669 25.3599 22.9189 25.497C22.6708 25.6342 22.3899 25.7066 22.1038 25.7068H13.8971H13.6471V25.9568V29.75H10.3529V25.9568V25.7068Z",
    fill: "#408E8D",
    stroke: "#FFC20E",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.345L9.57143 21L11.2857 14.4791H9C9.57143 13.156 10.8286 10.283 11.2857 9.37571C12.4286 8.69526 13.8571 9.09219 14.4286 9.37571L12.4286 13.345H15Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalAcMax22KwKaracsony);
export default __webpack_public_path__ + "static/media/normal_ac_max22kw_karacsony.840159a86cc52f7c01ca09492441e865.svg";
export { ForwardRef as ReactComponent };